import logo from '../images/logoDLA.png';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFacebook } from '@fortawesome/free-brands-svg-icons';
import { useTranslation } from 'react-i18next';
import { useLocation } from 'react-router-dom';

function Footer() {
    const { t } = useTranslation();
    const { pathname } = useLocation();
    const isContactPage = pathname === '/nousjoindre';

    return (
        <footer className="site-footer bg-gray pt-32" data-navbar-theme="dark">
            {!isContactPage && (
                <div className="site-footer__cta flex justify-center justify-between items-center border-bottom-white">
                    <p className="site-footer__cta-text text-title2 fustat text-semibold t-white m-0">
                        {t('footer.ctaText')}
                    </p>
                    <a href="/nousjoindre" className="site-footer__cta-link text-title2 text-light btn-link-white text-underline">
                        {t('footer.contact')}
                    </a>
                </div>
            )}

            <div className="site-footer__main flex justify-center justify-between items-start">
                <div className="site-footer__brand">
                    <img src={logo} alt="Groupe DLA" height={100} className="site-footer__logo" />
                    <a
                        href="https://maps.app.goo.gl/GgaqgR7fEU32MWjN7"
                        target="_blank"
                        rel="noopener noreferrer"
                        className="site-footer__address text-subtitle2 text-extralight outfit t-white m-0"
                    >
                        575 Rue Commerciale, La Tuque, QC G9X 3A7
                    </a>
                    <a href="tel:8195236030" className="site-footer__phone text-subtitle2 text-extralight outfit t-white m-0">(819) 523-6030</a>
                    <a href="https://www.facebook.com/profile.php?id=61584466692318" target="_blank" rel="noopener noreferrer" className="site-footer__social" aria-label="Facebook">
                        <FontAwesomeIcon icon={faFacebook} className="site-footer__social-icon" />
                    </a>
                </div>

                <div className="site-footer__nav-groups flex">
                    <div className="site-footer__nav flex flex-column gap-16">
                        <a href="/" className="btn-link-white text-subtitle text-extralight outfit t-white text-deco-none">{t('footer.home')}</a>
                        <a href="/propos" className="btn-link-white text-subtitle text-extralight outfit t-white text-deco-none">{t('footer.about')}</a>
                        <a href="/services" className="btn-link-white text-subtitle text-extralight outfit t-white text-deco-none">{t('footer.services')}</a>
                        <a href="/realisations" className="btn-link-white text-subtitle text-extralight outfit t-white text-deco-none">{t('footer.projects')}</a>
                        <a href="/carriere" className="btn-link-white text-subtitle text-extralight outfit t-white text-deco-none">{t('footer.careers')}</a>
                    </div>
                    <div className="site-footer__nav site-footer__nav--services flex flex-column gap-16">
                        <a href="/services#batiment" className="btn-link-white text-subtitle text-extralight outfit t-white text-deco-none">{t('footer.building')}</a>
                        <a href="/services#industriel" className="btn-link-white text-subtitle text-extralight outfit t-white text-deco-none">{t('footer.industrial')}</a>
                        <a href="/services#municipal" className="btn-link-white text-subtitle text-extralight outfit t-white text-deco-none">{t('footer.municipal')}</a>
                        <a href="/services#gestion-de-projets" className="btn-link-white text-subtitle text-extralight outfit t-white text-deco-none">{t('footer.projectManagement')}</a>
                        <a href="/services#autres" className="btn-link-white text-subtitle text-extralight outfit t-white text-deco-none">{t('footer.other')}</a>
                    </div>
                </div>
            </div>

            <div className="site-footer__legal flex justify-between items-center opacity-50 bg-graydark">
                <p className="text-small text-extralight outfit t-white m-0">{t('footer.copyright')}</p>
                <a
                    href="https://lmstechnologies.ca"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="btn-link-white text-small text-extralight outfit text-deco-none"
                >
                    {t('footer.madeBy')} <span className="t-lmsblue">LMS Technologies</span>
                </a>
            </div>
        </footer>
    );
}

export default Footer;
